<template>
  <div>
    <h5 class="mb-3">{{$t('Datos del usuario')}}</h5>
    <b-row>
      <b-col md="12">
        <b-form-group
          horizontal
          :label-cols="2"
          :label="$t('Nombre')"
          :invalid-feedback="!state.firstName? $t('El nombre es invalido'): ''"
          :state="state.firstName"
        >
          <b-form-input v-model="user.firstName"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group
          horizontal
          :label-cols="2"
          :label="$t('Apellido')"
          :invalid-feedback="!state.lastName? $t('El apellido es invalido') : ''"
          :state="state.lastName"
        >
          <b-form-input v-model="user.lastName"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group
          horizontal
          :label="$t('Correo')"
          :label-cols="2"
          :description="Boolean(verifyInProgress) ? $t('Verificando el correo, espere...') : ''"
          :invalid-feedback="$t(emailFeedBack)"
          :state="state.email && uniqueEmail"
        >
          <b-form-input v-model="email"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="mb-5 mt-2">
        <b-form-group
          horizontal
          :label="$t('Activar envío de mail')"
          :label-cols="2"
        >
          <b-form-checkbox v-model="user.activeSendEmail"></b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import { RoleService, AdminServiceMixin, OrganizationService } from '@/mixims/AdminServiceMixin'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'

export default {
  mixins: [RoleService, AdminServiceMixin, OrganizationService, ValidationsMixim],
  props: ['user', 'state'],
  data () {
    return {
      loading: false,
      emailValidation: true,
      emailFeedBack: '',
      timeout: null,
      prev: '',
      verifyInProgress: false,
      isAdmin: this.$store.getters.isAdmin,
      uniqueEmail: true,
      selectedAction: 'create'
    }
  },
  methods: {
    handleInvalidFeedback () {
      if (!this.user.email || this.user.email === '') this.emailFeedBack = 'El email es obligatorio'
      else if (!this.validateEmail(this.user.email, true)) this.emailFeedBack = 'Email inválido'
      else this.emailFeedBack = ''
    }
  },
  computed: {
    email: {
      set (newVal) {
        this.uniqueEmail = false
        this.user.email = newVal
        if (this.user.id && this.prev === newVal) {
          this.emailValidation = true
          clearTimeout(this.timeout)
          return
        }
        this.emailValidation = false
        this.handleInvalidFeedback()
        if (this.validateEmail(newVal, true)) {
          this.loading = true
          this.verifyInProgress = true
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.existEmail(this.user.email || '').then(res => {
              this.emailValidation = !res.body
              this.verifyInProgress = false
              if (!this.emailValidation) {
                this.emailFeedBack = 'El correo ingresado se encuentra en uso'
                this.uniqueEmail = false
                this.$emit('update:uniqueEmail', false)
                this.loading = false
                this.selectedAction = 'create'
                return false
              } else {
                this.uniqueEmail = true
                this.$emit('update:uniqueEmail', true)
                this.loading = false
                this.selectedAction = 'update'
                return true
              }
            })
          }, 2000)
        }
      },
      get () {
        this.handleInvalidFeedback()
        return this.user.email
      }
    }
  },
  watch: {
    user (newUser, oldUser) {
      if (newUser.id !== oldUser.id) {
        this.prev = newUser.email
      }
    },
    action (value) {
      this.selectedAction = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .disclaimer {
    background-color: #f5f3f3;
    border-radius: 5px;
    margin-top: 20px;
    padding: 10px 25px;
    color: #777777;
    font-size: 14px;
  }
</style>